import gql from 'graphql-tag';

export const notification = gql`
  fragment notification on Notification {
    id
    accountId
    userId
    createdBy
    type
    category
    scope
    recipientType
    status
    priority
    title
    body
    actionUrl
    actionText
    language
    channels
    data
    metadata
    isReminder
    scheduledFor
    expiresAt
    sentAt
    deliveredAt
    readAt
    deliveryAttempts {
      channel
      attemptedAt
      status
      provider
      error
      response
    }
    createdAt
    updatedAt
  }
`;
